<template>
	<div>
		<loading id="spinner" :active="false" :can-cancel="false" :is-full-page="true"></loading>
		<div class="row">
			<div class="input-field col s12 m12 l12 xl12">
				<input id="projeto" name="projeto" type="text" required v-model='vol.projeto'>
				<label for="projeto" class='active'>Título da Ação</label>
			</div>
		</div>
		<div class="row">
			<div class="file-field input-field col s12 m4 l4 xl4">
				<div class="btn">
					<i class="material-icons right">upload</i><span>PDF</span>
					<input id="pdf" name="pdf" type="file" accept='application/pdf' title='Fazer upload do arquivo.'>
				</div> 
				<div class="file-path-wrapper"> 
					<input v-if='vol.id' class="file-path validate" type="text" required :value="'voluntarios-' + vol.id + '.pdf'">
					<input v-else class="file-path validate" type="text" required>
				</div>
			</div>
			<div class="file-field input-field col s12 m2 l2 xl2">
				<a v-if='vol.id' class='btn' :href='"/voluntarios/pdf/" + vol.id' target='_blank'><i class="material-icons right">download</i><span>PDF</span></a> 
			</div>
		</div>
		<div class="row">
			<div class="input-field col s12 m6 l6 xl6">
				<input id="cpf" name="cpf" type="text" class="validate" @input="verifyCpf" maxlength="11" v-model='usu.cpf' :disabled='vol.id != 0'
						v-bind:class="{ 'red-text': usu.cpf.length != 11, 'green-text': usu.cpf.length == 11 }" required>
				<label for="cpf">CPF <small>(somente números)</small></label>
			</div>
			<div class="input-field col s12 m6 l6 xl6">
				<input disabled id="email" name="email" type="text"  v-model='usu.email' required>
				<label for="email" class='active'>e-mail</label>
			</div>
		</div>
		<div class="row">
			<div class="input-field col s12 m6 l6 xl6">
				<input disabled id="name" name="name" type="text"  v-model='usu.name' required>
				<label for="name" class='active'>Nome</label>
			</div>
			<div class="input-field col s12 m6 l6 xl6">
				<input readonly id="nome_social" name="nome_social" type="text"  v-model='usu.nome_social' required>
				<label for="nome_social" class='active'>Nome social</label>
			</div>
		</div>
		<div class="row">
			<div class="input-field col s12 m6 l6 xl6">
				<input disabled id="curso" name="sira" type="text"  v-model='usu.bolsista.sira' required>
				<label for="sira" class='active'>DRE</label>
			</div>
			<div class="input-field col s12 m6 l6 xl6">
				<input disabled id="curso" name="curso" type="text"  v-model='usu.bolsista.curso' required>
				<label for="curso" class='active'>Curso</small></label>
			</div>
		</div>
		
		<div class="row">
			<div class="input-field col s12 m6 l6 xl6">
				<input disabled id="lattes" name="lattes" type="text"  v-model='usu.bolsista.lattes' required>
				<label for="lattes" class='active'>ID do Lattes</small></label>
			</div>
		</div>
		
		<input type="hidden" id="aluno_id" name="aluno_id" v-model='usu.id'>
		
		<div class="row">
			<div class="input-field col s6 m3 l3 xl3">
				<button type="submit" class="btn" :disabled='!usu.id'>
					<i class="material-icons left">save</i>
				Salvar</button>
			</div>
			<div class="input-field col s6 m3 l3 xl3">
				<button type="reset" class="btn indigo" @click="clear">
					<i class="material-icons right">clear</i>
						Limpar</button>
			</div>
		</div>
	</div>
</template>

<script>
	import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
	
    export default {
		name: "VueVoluntarioAtribuicaoForm",
		props: [
			'voluntario'
		],
		components: {
            Loading
        },
		data () {
			return {
				vol: JSON.parse(this.voluntario),
				usu: JSON.parse(this.voluntario).aluno
			}
		},
		computed: {

		},
		methods: {
			verifyCpf() {
				if (this.usu.cpf.length == 11) {
					this.$http.get('/api/bolsas/bolsista/false/' + this.usu.cpf).then((req) => {
						if (req.data) {
							this.usu = req.data;
							document.getElementById('aluno_id').value = this.usu.id;
						}
				  }).catch(error => {
						showMsg(error.data.msg, 0);
						this.clear(null, this.usu.cpf);		
				  });
				} else 
					this.clear(null, this.usu.cpf)
			},
			clear (ev, cpfInput = '') {
				this.usu = {
					cpf: cpfInput,
					name: '',
					email: '',
					nome_social: '',
					bolsista: {lattes: '', sira: '', curso: ''}
				}
			},
		},
		mounted: function () {
			$("#pdf").off();
		},

    }
</script>
